import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    IconButton,
    Typography,
} from '@mui/material';
import { Close } from "@mui/icons-material";
import { CheckNullEmptyUndefined } from "../Utils/participantInfo";

export interface CustomPopupProps {
    BodyContent(): JSX.Element;
    togglePopupClose(): void;
    ConfirmHandler(): void;
    btnCancel: string;
    btnConfirm: string;
    lblTitle: string;
    popupHeight: string;
    isShowCloseButton: string;
}

export default (props: CustomPopupProps): JSX.Element => {
    const isClosebtn = (props.isShowCloseButton === 'true');
    return (
        <Dialog open={true} maxWidth="sm" fullWidth style={{ height: props.popupHeight }}>
            <DialogTitle>
                {props.lblTitle}
            </DialogTitle>
            <Box position="absolute" top={0} right={0}>
                {isClosebtn && (
                    <IconButton onClick={() => props.togglePopupClose()}>
                        <Close />
                    </IconButton>
                )}
            </Box>
            <DialogContent>
                {props.BodyContent()}
            </DialogContent>
            <DialogActions>

                {CheckNullEmptyUndefined(props.btnCancel) && (
                    <Button color="inherit" variant="contained" onClick={() => props.togglePopupClose()}>
                        {props.btnCancel}
                    </Button>
                )}
                {CheckNullEmptyUndefined(props.btnConfirm) && (
                    <Button color="primary" variant="contained" onClick={(event) => props.ConfirmHandler()}>
                        {props.btnConfirm}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};
